
import Filter from "../../../assets/outline/Filter.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FilterIcon({ className, dataTestid = "FilterIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Filter data-testid={dataTestid} className={classes} {...rest} />
  );
}
